<template>
  <div>
    <p class="text-h6 pl-2">직원등록</p>
    <v-card class="white elevation-0" width="1000px">
      <v-form
        ref="form"
        class="pa-5"
        v-model="valid"
        lazy-validation
        container--fluid
      >
        <v-row>
          <!-- 부서 -->
          <v-col cols="6">
            <v-select
              v-model="dept"
              :items="teamItem"
              item-text="deptNm"
              item-value="deptNo"
              :rules="[rules.required]"
              label="부서"
              required
              return-object
            ></v-select
          ></v-col>
          <!-- 직급 -->
          <v-col cols="6"
            ><v-select
              v-model="rank"
              :items="rankItem"
              item-text="cdDtlNm"
              item-value="cdDtlNo"
              :rules="[rules.required]"
              label="직급"
              required
              return-object
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <!-- 이름 -->
          <v-col cols="6">
            <v-text-field
              v-model="empNm"
              :rules="[rules.required]"
              label="이름"
              required
            ></v-text-field>
          </v-col>
          <!--생년월일-->
          <v-col cols="6"
            ><v-text-field
              v-model="birthDt"
              :rules="[rules.required]"
              label="생년월일 (yymmdd)"
              required
            ></v-text-field
          ></v-col>
        </v-row>
        <v-row>
          <!--이메일-->
          <v-col cols="6">
            <v-text-field
              v-model="email"
              :rules="[rules.required]"
              suffix="@devmon.co.kr"
              label="이메일"
              required
            >
            </v-text-field>
          </v-col>
          <!--휴대폰번호-->
          <v-col cols="6"
            ><v-text-field
              v-model="mobile"
              :rules="[rules.required, rules.phone]"
              label="휴대폰번호 (- 포함)"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <!--내선번호-->
          <v-col cols="6">
            <v-text-field
              v-model="extensionTel"
              label="내선번호(0000)"
              single-line
            ></v-text-field
          ></v-col>
          <!-- 비상연락망 -->
          <v-col cols="6"
            ><v-text-field
              v-model="emergencyTel"
              label="비상연락망( - 포함)"
              single-line
            ></v-text-field
          ></v-col>
        </v-row>
        <!-- 주소 -->
        <v-row>
          <v-col cols="2"
            ><v-text-field
              v-model="postResult.zonecode"
              label="우편번호"
            ></v-text-field
          ></v-col>
          <v-col cols="4"
            ><v-text-field
              v-model="postResult.roadAddress"
              label="기본주소"
            ></v-text-field
          ></v-col>
          <v-col cols="4"
            ><v-text-field
              v-model="detailAddress"
              label="상세주소"
            ></v-text-field
          ></v-col>
          <v-btn
            cols="2"
            class="mt-7 elevation-0 text-right"
            @click.stop="postPop = true"
            outlined
            color="success"
            >주소검색</v-btn
          >
        </v-row>
        <v-row>
          <!--입사일-->
          <v-col cols="6">
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              label="입사일"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="computedDateFormattedMomentjs"
                  label="입사일"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                ref="picker"
                v-model="date"
                :max="new Date().toISOString().substr(0, 10)"
                min="1950-01-01"
                locale="ko"
                @change="save"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <!--부여 휴가일-->
          <v-col cols="6">
            <v-text-field
              v-model="totLeaveDay"
              :rules="[rules.required]"
              label="부여 휴가일"
              required
            ></v-text-field
          ></v-col>
        </v-row>
        <!--btn-->
        <div class="btn_area text-center">
          <v-btn outlined color="yellow darken-3" class="mr-4">
            취소
          </v-btn>
          <v-btn
            :disabled="!valid"
            class="white--text mr-4 elevation-0"
            color="yellow darken-3"
            @click="submitForm"
          >
            저장
          </v-btn>
          <v-btn color="error" class=" elevation-0" @click="reset">
            초기화
          </v-btn>
        </div>
      </v-form>
    </v-card>
    <!--우편번호 팝업 -->
    <v-dialog v-model="postPop" max-width="500">
      <v-card class="address-popup">
        <div class="text-right">
          <v-btn text @click="openPostPop">X</v-btn>
        </div>
        <vue-daum-postcode
          style="height:500px;"
          @complete="searchPost"
          :key="componentKey"
          ref="postPopup"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { VueDaumPostcode } from "vue-daum-postcode";
import { empSet, empList } from "@/api/employee.js";

export default {
  components: {
    VueDaumPostcode,
  },
  data: () => ({
    valid: true,
    rules: {
      required: v => !!v || "입력해주세요.",
      phone: v =>
        /^\d{3}-\d{3,4}-\d{4}$/.test(v) || "잘못된 휴대폰번호 형식입니다.",
      call: v =>
        /^\d{2,3}-\d{3,4}-\d{4}$/.test(v) || "잘못된 전화번호 형식입니다.",
    },
    teamItem: [],
    rankItem: [],
    dept: "",
    rank: "",
    empNm: "",
    birthDt: "",
    email: "",
    mobile: "",
    emergencyTel: "",
    extensionTel: "",
    detailAddress: "",
    totLeaveDay: "15",

    // datepicker
    date: new Date().toISOString().substr(0, 10),
    menu: false,
    // address popup
    postResult: {},
    postPop: false,
    componentKey: 0,
  }),
  computed: {
    computedDateFormattedMomentjs() {
      return this.date ? moment(this.date).format("YYYYMMDD") : "";
    },
  },
  async created() {
    try {
      const { data } = await empList();
      this.teamItem = data.deptList;
      this.rankItem = data.empRankList;
    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    async submitForm() {
      this.$refs.form.validate();

      const userData = {
        deptNm: this.dept.deptNm,
        deptNo: this.dept.deptNo, //부서코드
        empNm: this.empNm, //이름
        empRank: this.rank.cdDtlNm, //직급
        empRankCd: this.rank.cdDtlNo, //직급코드
        birthDt: this.birthDt,
        email: `${this.email}@devmon.co.kr`,
        mobile: this.mobile,
        emergencyTel: this.emergencyTel,
        extensionTel: this.extensionTel,
        addr: this.postResult.roadAddress,
        dtlAddr: this.detailAddress,
        zipcd: this.postResult.zonecode,
        empJoinDt: moment(this.date).format("YYYYMMDD"),
        totLeaveDay: this.totLeaveDay,
      };
      const { data } = await empSet(userData);

      // this.$refs.form.reset();
      window.location.reload();

      try {
        console.log(data);
      } catch (error) {
        console.log(error);
      }
    },
    reset() {
      this.$refs.form.reset();
    },
    save(date) {
      this.$refs.menu.save(date);
    },
    searchPost(event) {
      this.postResult = event;
      this.postPop = false;
    },
    openPostPop() {
      this.postPop = false;
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped lang="scss">
.address-popup {
  padding: 0 10px;
}
</style>
